
  import React from 'react';;

  export const frontMatter = {};

  export default class ReactMarkdown extends React.PureComponent {
    render() {
      const props = this.props;

      return <div>
  <h2>何それ</h2>
  <p>エフェクタ/effectorは、MonoMotionフレームワーク内部で新しく作られた、モーションの中での<strong>ロボットのパーツの理想的な姿勢を表現する</strong>概念です。</p>
  <p>エフェクタをうまく使うことによって、MonoMotionはロボットの形やモーションの目的にかかわらず一般的に使えるフレームワークになっています。</p>
  <h2>なんでこれが必要なのか</h2>
  <p>ヒューマノイドロボットの歩行<em>だけ</em>に対応させるならば、「前に進めば進むほど報酬が高い」という方針をコードで記述すれば良いです。しかし任意のロボットの任意のモーションに対応させるとなるとどうでしょう。ユーザーに方針を記述してもらうのにPythonコードを書かせるのはよくありません。</p>
  <p>私たちは、「この時間地点において部品Xがこの姿勢をしている」というデータを記録しておくことによって、歩行に限らず、任意のロボットの任意のモーションについて期待する動きを表現できると考えました。</p>
  <h3>全てのパーツの動きを記録しておくのではいけないのか？</h3>
  <p>それでもうまくいく時はいくでしょうが、例えば歩行であれば特に腰板の動きは重要だが肩の動きは重要ではないなど、特に重点を置きたい/気にしなくても良い、と言ったようにパーツを意味付けする必要が出てきます。</p>
  <h2>どのように報酬に変換するのか</h2>
  <p>ご自由にどうぞ...例えばEffectorと実際の二乗誤差を取ってみるなど</p>
  <h2>なるほど。使ってみたいがライブラリを書くのは面倒だ</h2>
  <p><a href="/technology/flom">flom</a>で使えます ぜひ</p>
</div>
;
    }
  }